import { createAction } from '../../../core/helpers'

import {
  CLEAR_TRANSFER_KEYWORD_ERROR,
  TOGGLE_TRANSFER_KEYWORDS_TO_KEYWORD_NODE,
  TRANSFER_KEYWORDS_TO_INGREDIENT_KEYWORD_NODE,
  TRANSFER_KEYWORDS_TO_KEYWORD_NODE,
  TRIGGER_TRANSFER_KEYWORDS_TO_DICTIONARY_TYPE,
} from '../action-types'

export const toggleTransferKeywordsToKeywordNode = createAction(
  TOGGLE_TRANSFER_KEYWORDS_TO_KEYWORD_NODE,
)

export const transferKeywordsToKeywordNode = createAction(
  TRANSFER_KEYWORDS_TO_KEYWORD_NODE,
)

export const transferKeywordsToIngredientKeywordNode = createAction(
  TRANSFER_KEYWORDS_TO_INGREDIENT_KEYWORD_NODE,
)

export const triggerTransferKeywordsToDictionaryType = createAction(
  TRIGGER_TRANSFER_KEYWORDS_TO_DICTIONARY_TYPE,
)

export const clearTransferKeywordError = createAction(
  CLEAR_TRANSFER_KEYWORD_ERROR,
)
